import { createDomainTracker } from './createDomainTracker';

export { createDomainTracker } from './createDomainTracker';
export type { AnalyticsEvent } from './types';

export const { hook: useGlobalTracker } = createDomainTracker({});
